<template>
  <div class="upload-multi component">
    <div class="top-tools">
      <span v-if="fileList.length">{{ fileList.length }} files selected</span>

      <label for="selectFilesInput" class="select-btn">select file</label>
      <input id="selectFilesInput" type="file" accept="image/*" @change="onChange" ref="filesContainer" multiple>

      <button @click="upload" :disabled="!fileList.length">upload</button>
      <button @click="resetSelection">cancel</button>
    </div>

    <div class="loading-status">
      <div class="loading" v-if="loading">loading ({{ uploadedFilesCounter }} of {{ fileList.length }})</div>
      <div class="done" v-if="done">loaded, all done</div>
      <div class="error" v-if="error">Error: {{ error }}</div>
    </div>

    <div class="selected-files">
      <div class="file" v-for="(item, index) in fileList" :key="index">
        <span>{{ item.name }}</span>
        <span>{{ parseInt(item.size / 1024) }}kb</span>
        <button @click="removeFile(index)" class="remove-btn">remove</button>
      </div>
    </div>
  </div>
</template>

<script>
  import Promise from 'bluebird'
  import * as albumsApi from '../services/albums.service'

  export default {
    name: 'UploadMulti',

    props: {
      entityId: {
        type: Number
      },
      maxSize: {
        type: Number,
        default: 1024 * 1024 * 2 // 1MB
      },
      maxFiles: {
        type: Number,
        default: 300
      },
      types: {
        type: Array,
        default: () => ['jpg', 'jpeg']
      }
    },

    data () {
      return {
        loading: false,
        done: false,
        error: false,
        previewImageData: '',
        fileList: [],
        uploadedFilesCounter: 0
      }
    },

    methods: {
      makePreviewImage (event) {
        // Reference to the DOM input element
        let input = event.target
        // Ensure that you have a file before attempting to read it
        if (input.files && input.files[0]) {
          // create a new FileReader to read this image and convert to base64 format
          let reader = new FileReader()
          // Define a callback function to run, when FileReader finishes its job
          reader.onload = (e) => {
            // Note: arrow function used here, so that "this.previewImageData" refers to the previewImageData of Vue component
            // Read image as base64 and set to imageData
            this.previewImageData = e.target.result
          }
          // Start the reader job - read file as a data url (base64 format)
          reader.readAsDataURL(input.files[0])
        }
        this.previewImageData = ''
        this.resetAllStatuses()
      },
      onChange (event) {
        const selectedFiles = event.target.files

        if (this.isValidFiles(selectedFiles)) {
          Array.from(selectedFiles).forEach(file => {
            this.fileList.push(file)
          })
        }
      },
      upload () {
        if (!this.fileList.length) return

        this.loading = true
        Promise.each(this.fileList, file => {
          this.uploadedFilesCounter++
          const formData = new FormData()
          formData.append('photo', file)

          return albumsApi.uploadPhotoToAlbum(this.entityId, formData)
        }).then(response => {
          this.done = true
          this.$emit('uploaded')
        }).catch(error => {
          this.$snotify.error(error.message, 'Error')
          console.log(error)
        }).finally(() => {
          this.loading = false
          this.fileList = []
        })
      },
      resetSelection () {
        this.previewImageData = ''
        this.resetAllStatuses()
        this.fileList = []
      },
      resetAllStatuses () {
        this.loading = false
        this.done = false
        this.error = false
      },
      removeFile (fileId) {
        this.fileList.splice(fileId, 1)
      },
      isValidFiles (files) {
        let isValid = true
        this.resetSelection()

        if (files.length > this.maxFiles) {
          this.error = `Too many files. ${this.maxFiles} files allowed per time.`
          return (isValid = false)
        }

        Array.from(files).forEach(file => {
          let extension = file.name.substring(file.name.lastIndexOf('.') + 1)

          if (file.size > this.maxSize) {
            this.error = `Max size per file = ${this.maxSize / 1024 / 1024} MB.`
            return (isValid = false)
          }
          if (!this.types.includes(extension)) {
            this.error = `Not allowed file type.`
            return (isValid = false)
          }
        })

        return isValid
      }
    }
  }
</script>

<style lang="scss" scoped>
  .upload-multi.component {
    #selectFilesInput {
      display: none;
    }
    .select-btn {
      cursor: pointer;
      padding: 5px;
      background-color: $color-gray-transparent;
    }
    .top-tools {
      padding: 15px 0;
      text-align: center;
    }
    .selected-files {
      .file{
        padding: 10px;
        &:hover {
          background-color: $color-gray-transparent;
        }
        .remove-btn {
          cursor: pointer;
          margin-left: 10px;
        }
      }
    }
    .loading-status {
      text-align: center;
      padding-bottom: 15px;
      top: 40%;
      left: 45%;
      font-size: 16px;
    }
  }

</style>



// WEBPACK FOOTER //
// src/components/UploadMulti.vue